export default "__VITE_ASSET__OFkq5yBAjMqRj2eJc6Typw__"